// export default Header;
import React, { useState } from "react";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  const closeMenu = () => setIsOpen(false);

  return (
    <div id="header" className="header">
      <div className="header-inner">
        <div className="logo">
          <a href="#">
            <img src="/img/logo-light.png" style={{ height: 60 }} />
          </a>
        </div>

        {/* FIXED HAMBURGER BUTTON */}
        {/* <div
          className="nav-menu-icon"
          onClick={() => setIsOpen(!isOpen)}
          style={{ cursor: "pointer" }}
        >
          <i className="fa fa-bars"></i>
        </div> */}

        <div className="nav-menu-icon" onClick={() => setIsOpen(!isOpen)}>
          <a>
            <i class="fa fa-bars"></i>
          </a>
        </div>

        {/* APPLY OPEN/CLOSE CLASS */}
        <div className={`nav-menu singlepage-nav ${isOpen ? "open" : ""}`}>
          <ul className="nav-menu-inner">
            <li>
              <a href="#intro" onClick={closeMenu}>
                Home
              </a>
            </li>
            <li>
              <a href="#about" onClick={closeMenu}>
                Why We Exist?
              </a>
            </li>
            <li>
              <a href="#mission" onClick={closeMenu}>
                Our Mission
              </a>
            </li>
            <li>
              <a href="#problems" onClick={closeMenu}>
                Problem Statement
              </a>
            </li>
            <li>
              <a href="#solution" onClick={closeMenu}>
                Our Solution
              </a>
            </li>
            <li>
              <a href="#process" onClick={closeMenu}>
                Our Process
              </a>
            </li>
            <li>
              <a href="#pricing" onClick={closeMenu}>
                Pricing
              </a>
            </li>

            <li>
              <a href="#portfolio" onClick={closeMenu}>
                Portfolio
              </a>
            </li>
            <li>
              <a href="#contact-us" onClick={closeMenu}>
                Contact
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Header;
